export default {
    annotationManifestURL: `${process.env.REACT_APP_EDITION_DATA_URL}/annotations/annotations.json`,
    annotations: {},
    annotationsByEntry: {},
    annotationSections: [],
    loaded: false
}	